
// Disabled at navigation.hbs

var stickyTop = 0;
var desktop = false;

function logo_onResize() {
    desktop = $('#logo-wrapper.toggleable').css('display') == 'none';
    if (desktop) {
        stickyTop = parseInt($('#foto-grup > figure').css('height'));
    }
}

function logo_onScroll() {
    var windowTop = $(window).scrollTop();
    if (stickyTop < windowTop) {
        $('#logo-wrapper.toggleable').show();
    } else {
        $('#logo-wrapper.toggleable').hide();
    }
}

$(window).on('resize', function() {
    if (desktop) {
        logo_onResize();
    }
});

$(window).on('scroll', function() {
    if (desktop) {
        logo_onScroll();
    }
});

$(document).ready(function() {
    desktop = $('#logo-wrapper.toggleable').css('display') == 'none';

    if (desktop) {
        logo_onResize();
        logo_onScroll();
    }
});
